import { Alert, Chip, Stack, Typography, type AlertProps } from '@mui/material';
import { messageFromAdminConsoleAxiosError } from '../../../lib/axiosErrorMessage';
import { iamErrorView } from '../../../lib/iamGrantability';

/**
 * admin-api error with its code shown (SELF_GRANT, ESCALATION, SUPER_ADMIN_ONLY, LAST_SUPER_ADMIN,
 * MFA_REQUIRED, …) and a plain-language hint. Renders nothing without an error.
 */
export function IamErrorAlert({
  error,
  severity = 'error',
  sx,
}: {
  error: unknown;
  severity?: AlertProps['severity'];
  sx?: AlertProps['sx'];
}) {
  if (!error) return null;
  const view = iamErrorView(error, messageFromAdminConsoleAxiosError(error));
  return (
    <Alert severity={severity} sx={sx}>
      <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap" useFlexGap>
        <span>{view.message}</span>
        {view.code && (
          <Chip
            size="small"
            variant="outlined"
            label={view.code}
            sx={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', height: 20 }}
          />
        )}
      </Stack>
      {view.hint && (
        <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
          {view.hint}
        </Typography>
      )}
    </Alert>
  );
}
